$(document).ready(function() {
    if($('.image-slider').length) {
        $('.image-slider').flickity({
            cellAlign: 'left',
            contain: true,
            wrapAround: false,
            groupCells: true,
            prevNextButtons: true,
            selectedAttraction: 0.1,
            friction: 0.8,
            pageDots: false,
            arrowShape: "M46.9456 74L51.0612 69.9286L34.1176 52.9464H78V47.0536H34.1176L51.0612 30.125L46.9456 26L23 50L46.9456 74Z"

        });
    }

    $(document).on('click', 'a[href^="#section-"]', function(e) {
        e.preventDefault();
        const section = $(this).attr('href');
        const sectionIndex = parseInt(section.replace('#section-', '')) - 1;
        const mainContentChildren = $('#MainContent').children();
        const target = mainContentChildren.eq(sectionIndex);
        if(!target.length) {
            return;
        }
        const targetOffset = target.offset().top;
        $('html, body').animate({
            scrollTop: targetOffset
        }, 500);
    });

    if($('.navbar-list').length){
        $('.navbar-list a').each(function(){
            if($(this).attr('href') == window.location.href || $(this).attr('href') == window.location.pathname){
                $(this).addClass('active');
            }
        });
    }

    $.fn.datepicker.language["en"] = {
        days: [
          "Sunday",
          "Monday",
          "Tuesday",
          "Wednesday",
          "Thursday",
          "Friday",
          "Saturday",
        ],
        daysShort: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
        daysMin: ["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"],
        months: [
          "January",
          "February",
          "March",
          "April",
          "May",
          "June",
          "July",
          "August",
          "September",
          "October",
          "November",
          "December",
        ],
        monthsShort: [
          "Jan",
          "Feb",
          "Mar",
          "Apr",
          "May",
          "Jun",
          "Jul",
          "Aug",
          "Sep",
          "Oct",
          "Nov",
          "Dec",
        ],
        today: "Today",
        clear: "Clear",
        dateFormat: "mm/dd/yyyy",
        timeFormat: "hh:ii aa",
        firstDay: 0,
    };
    if($('.date-picker').length){
        var startingDate = new Date();
        startingDate.setDate(startingDate.getDate());
        $('.date-picker').datepicker({
          dateFormat : 'MM dd, yyyy',
          language : 'en',
          minDate : startingDate,
          onShow: function(){
            var val = '';
            if($('.date-picker').val() != ''){
              val = $('.date-picker').val().split(' ');
              var months = $.fn.datepicker.language['en'].months;
              val[0] = months.indexOf(val[0]);
              val[1] = val[1].replace(',','');
            }
            if(val != '' && !$('.datepicker--cell.-selected-').length){
              $('.datepicker--cell[data-date="'+val[1]+'"][data-month="'+val[0]+'"][data-year="'+val[2]+'"]').addClass('-selected-');
            }
          },
          onSelect: function(formattedDate, date, inst) {
            var el = $(inst.$el);
            el.parent().removeClass('error');
            var datePickerData = el.data('datepicker');
            datePickerData.hide();
          }
        });
    }

    $(document).on('click', '#SortBy', function(){
      $('.sort-options-wrapper').toggleClass('active');
      if($('.sort-options-wrapper').hasClass('active')){
        const sortHeight = $('.sort-options').outerHeight();
        $('.sort-options-wrapper').outerHeight(sortHeight);
      }else{
        $('.sort-options-wrapper').outerHeight('0px');
      }
    });

    $(document).on('click', '.sort-options button', function(){
        var value = $(this).val();
        var url = new URL(window.location.href);
        url.searchParams.set('sort_by', value);
        window.location.href = url.href;
    });


    if($('.pdp-image-main').length){
      const mainCarousel = $('.pdp-image-main').flickity({
        sync: $('.pdp-image-thumbs')[0],
        cellAlign: "left",
        contain: true,
        pageDots: true,
        imagesLoaded: true,
        draggable: true,
        prevNextButtons: false
      });
      const flktyThumbs = $('.pdp-image-thumbs').flickity({
        sync: mainCarousel,
        contain: true,
        prevNextButtons: false,
        imagesLoaded: true,
        pageDots: false,
        draggable: true,
        cellAlign: "center"
      });

      let isSyncing = false;

      $(document).on('click','.pdp-image-thumb', function(){
          var clickedIndex = $(this).index();
          flktyThumbs.flickity('select', clickedIndex, true, true);
      });

      
      flktyThumbs.on('select.flickity', function(){
        const flktyData = flktyThumbs.data('flickity');
        const selected = flktyData.selectedIndex;
          if (isSyncing) return;
          isSyncing = true;
          mainCarousel.flickity('select', selected);
          isSyncing = false;
      });

      mainCarousel.on('select.flickity', function(){
        const flktyData = mainCarousel.data('flickity');
        const selected = flktyData.selectedIndex;
          if (isSyncing) return;
          isSyncing = true;
          flktyThumbs.flickity('select', selected);
          isSyncing = false;
      });

    };

    $(document).on('click', '.mobile-menu-button', function(){
      $('.mobile-menu-drawer').toggleClass('active');
      $('body').toggleClass('overflow-hidden');
    });
    $(document).on('click', '.mobile-menu-close, .mobile-menu-drawer .drawer-overlay', function(){
      $('.mobile-menu-drawer').toggleClass('active');
      $('body').toggleClass('overflow-hidden');
    });
    
    if($('.mobile-slider').length){
      $('.mobile-slider').flickity({
          cellAlign: 'left',
          contain: true,
          wrapAround: false,
          imagesLoaded: true,
          groupCells: true,
          prevNextButtons: false,
          watchCSS: true,
          pageDots: false,
      });
    }

    // if($('.product-grid').length || $('.related-products').length){
    //   let $cursor = $('.view-product-overlay');
    //   $(document).on('mousemove', function (e) {
    //     $cursor.css({
    //       left: e.clientX + 'px',
    //       top: e.clientY + 'px'
    //     });
    //   });

    //   $(document).on('mouseenter','.product-grid-item', function () {
    //     $cursor.addClass('show');
    //   });

    //   $(document).on('mouseleave','.product-grid-item', function () {
    //     $cursor.removeClass('show');
    //   });
    // }

});